import React, { useContext } from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import { ThemeContext } from 'styled-components';
import { UptimeTypography, HlxButton } from '@uptime/uptime-component';
import CircleIcon from '@mui/icons-material/Circle';
import DateUtils from 'utils/date';

enum ORDER_ITEM_STATUS {
  PENDING_APPROVAL = 'pending_approval',
  ORDERED = 'ordered',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELED = 'canceled',
  SHIPPED_EXCEPTION = 'shipped_exception',
  PENDING = 'pending',
  APPROVED = 'approved',
  NOT_APPROVED = 'not_approved',
}

const statusStageText: { [key: string]: string } = {
  [ORDER_ITEM_STATUS.PENDING]: 'Open',
  [ORDER_ITEM_STATUS.PENDING_APPROVAL]: 'Open',
  [ORDER_ITEM_STATUS.SHIPPED]: 'Closed',
  [ORDER_ITEM_STATUS.NOT_APPROVED]: 'Closed',
  [ORDER_ITEM_STATUS.APPROVED]: 'Closed',
};

const OrdersNotification = (props: any) => {
  const {
    item,
    onViewDetailsClick,
    notificationsLocale,
    delegatedLocale,
    statusLocale,
    commonStatus
  } = props;
  const theme = useContext(ThemeContext);
  const assetTicketLocale = {...commonStatus?.asset, ...commonStatus?.ticket};
  const state = statusStageText[item?.approval?.approval_status] || item.state;
  return (
    <Alert
      icon={
        <ReceiptRoundedIcon
          sx={{
            color: theme.uptimeColors.mainTheme.primary,
            fontSize: `${theme.uptimeFontSizes.desktop.fz9}px`,
          }}
        />
      }
      severity="info"
      sx={{ bgcolor: theme.uptimeColors.mainTheme.background }}
    >
      <Box display="flex" gap={`${theme.uptimeSpace[4]}px`}>
        <AlertTitle>
          <UptimeTypography
            kind="h6"
            fontWeight={600}
            lineHeight={`${theme.uptimeLineHeights.desktop.lh7}px`}
            color={`${theme.uptimeColors.textColors.primary}`}
            fontSize={`${theme.uptimeFontSizes.desktop.fz5}px`}
            margin="0"
            display="inline"
          >
            {`${
              item.isRequestItem
                ? notificationsLocale?.orderLabel
                : notificationsLocale?.approvalLabel
            } #${item?.number || item?._id?.slice(0, 11)}`}
          </UptimeTypography>
          &nbsp;
          <UptimeTypography
            kind="body1"
            fontWeight={400}
            lineHeight={`${theme.uptimeLineHeights.desktop.lh6}px`}
            color={`${theme.uptimeColors.textColors.secondary}`}
            fontSize={`${theme.uptimeFontSizes.desktop.fz5}px`}
            margin="0"
            display="inline"
            letterSpacing="0.15px"
          >
            {item.isRequestItem
              ? `${(assetTicketLocale[item.state?.toUpperCase()])?.toLowerCase()}`
              : `${(assetTicketLocale[state?.toUpperCase()])?.toLowerCase()}${
                  item?.approval?.approver_type === 'delegated' ||
                  item?.approver?.delegate
                    ? ` ${delegatedLocale}`
                    : ''
                }`}{' '}
            —{' '}
            {item?.shortDescription
              ? item.shortDescription
              : `${item?.requestItem?.shortDescription ||
                  notificationsLocale?.requestedItems}`}{' '}
            {(item?.status || item?.variables?.stage?.display_value || item?.isApproval) &&
              `${notificationsLocale?.and} 
            ${item.isRequestItem
                ? `${(assetTicketLocale[item.originalState?.toUpperCase()])?.toLowerCase()}`
                : `${item?.order_detail?.meta_status?.status === 'pending_approval'
                  ? statusLocale?.toLowerCase()
                  : `${(assetTicketLocale[item.originalState?.toUpperCase()])?.toLowerCase()}`
                }`}`}
          </UptimeTypography>
        </AlertTitle>
        <CircleIcon
          sx={{
            color: theme.uptimeColors.generalColors.state.danger.dark,
            fontSize: `${theme.uptimeFontSizes.desktop.fz1}px`,
          }}
        />
      </Box>
      <UptimeTypography
        kind="body2"
        fontWeight={400}
        lineHeight={`${theme.uptimeLineHeights.desktop.lh4}px`}
        color={`${theme.uptimeColors.textColors.secondary}`}
        fontSize={`${theme.uptimeFontSizes.desktop.fz4}px`}
        margin="0"
        letterSpacing="0.17px"
      >
        {`${DateUtils.timetoXbyGMT(item.updatedOn)} ${
          notificationsLocale?.at
        } ${DateUtils.formatDate(item.updatedOn, 'hh:mm a')}`}
      </UptimeTypography>

      <Box display="flex" justifyContent="flex-end">
        {onViewDetailsClick && (
          <HlxButton
            variant="text"
            onClick={() => onViewDetailsClick(item)}
            label={(notificationsLocale?.viewDetails)}
          />
        )}
      </Box>
    </Alert>
  );
};

export default OrdersNotification;
